import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const DokumenService = {}

DokumenService.postDokumen = function (token,data) {

    return fetch({
        url: '/dokumen/pendaftar/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

DokumenService.delDokumen = function (token,id_dokumen_pendaftar) {
    return fetch({
        url: '/dokumen/pendaftar/delete',
        method: 'delete',
        params: {
            "id_dokumen_pendaftar":id_dokumen_pendaftar
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

DokumenService.cekSyaratDokumen = function (token,data) {
    //console.log(data)
    return fetch({
        url: '/dokumen/pendaftar/cekdata',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

DokumenService.viewFile = function (token,id_pendaftar,id_dokumen_pendaftar) {

    return fetch({
        url: '/dokumen/pendaftar/get',
        method: 'get',
        params: {
            id_pendaftar,
            id_dokumen_pendaftar
        },
        headers:{
            "x-api-key":X_API_KEY,
        }
    })
}

DokumenService.hasilSeleksi = function (token,tipe) {

    return fetch({
        url: '/dokumen/pendaftar/template',
        method: 'get',
        params: {
            "tipe":tipe
        },
        headers:{
            "x-api-key":X_API_KEY,
        }
    })
}

export default DokumenService;
